import React from 'react';
import { getPrimaryImagePathFromOrderItem, lineQty, pickRowBackground } from './adminOrderScannerPickUtils';
import { ScannerPickImageWithLightbox } from './ScannerPickImageWithLightbox';
import { WrongScanDetails } from './ScannerPickWrongScanDisplay';

/**
 * Десктоп: таблиця позицій, без зайвих ефектів — зручно для швидкої збірки.
 */
const AdminOrderScannerPickModalDesktop = ({ pick, order, onHide }) => {
  const {
    inputRef,
    barcode,
    setBarcode,
    scannedCounts,
    wrongScans,
    submitScan,
    handlePaste,
    removeWrong,
    items,
    perfectPick,
    allExpectedDone,
    hasWrong,
    pickLoading,
  } = pick;

  return (
    <div
      className='modal fade show'
      tabIndex='-1'
      role='dialog'
      aria-modal='true'
      style={{ display: 'block', background: 'rgba(0,0,0,0.45)' }}
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) onHide();
      }}
    >
      <div
        className='modal-dialog modal-xl modal-dialog-scrollable'
        role='document'
        style={{ maxWidth: 'min(1100px, calc(100vw - 2.5rem))' }}
      >
        <div className='modal-content'>
          <div className='modal-header py-2 px-3'>
            <h5 className='modal-title font-weight-bold mb-0'>Збірка сканером #{order.orderId}</h5>
            <button type='button' className='close' aria-label='Закрити' onClick={onHide}>
              <span aria-hidden='true'>&times;</span>
            </button>
          </div>

          <div className='modal-body p-3'>
            {perfectPick && (
              <div className='alert alert-success py-2 px-3 mb-3 small' role='alert'>
                <i className='bi bi-check-circle-fill mr-1' />
                Усі позиції відскановано, збірка збігається з замовленням.
              </div>
            )}
            {allExpectedDone && hasWrong && (
              <div className='alert alert-warning py-2 px-3 mb-3 small' role='alert'>
                <i className='bi bi-exclamation-triangle-fill mr-1' />
                Позиції замовлення зібрані, але є зайві сканування — видаліть їх або закрийте вікно.
              </div>
            )}

            <input
              id='scanner-pick-desktop-input'
              ref={inputRef}
              type='text'
              aria-label='Поле сканування штрихкоду'
              className='form-control mb-3'
              style={{ height: '46px', fontSize: '1rem' }}
              placeholder='Скануйте або введіть код, Enter — підтвердити'
              value={barcode}
              disabled={pickLoading}
              autoComplete='off'
              onPaste={handlePaste}
              onChange={(e) => {
                const value = e.target.value || '';
                if (value.includes('\n') || value.includes('\r')) {
                  const normalized = value.replace(/\r/g, '\n');
                  const firstCode = normalized.split('\n').find((part) => part.trim() !== '');
                  if (firstCode) submitScan(firstCode.trim());
                  setBarcode('');
                  return;
                }
                setBarcode(value);
              }}
              onKeyDown={(e) => e.key === 'Enter' && submitScan()}
            />

            <div className='table-responsive border rounded' style={{ maxHeight: 'min(56vh, 520px)' }}>
              <table className='table table-hover table-sm table-bordered mb-0 small'>
                <thead className='thead-light'>
                  <tr>
                    <th className='text-center align-middle' style={{ width: 52 }}>
                      Фото
                    </th>
                    <th className='align-middle'>Товар</th>
                    <th className='align-middle' style={{ width: '18%' }}>
                      Артикул
                    </th>
                    <th className='align-middle' style={{ width: '18%' }}>
                      Штрихкод
                    </th>
                    <th className='text-center align-middle' style={{ width: 72 }}>
                      Кіл-ть
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {items.map((item, index) => {
                    const need = lineQty(item);
                    const got = scannedCounts[index] || 0;
                    const imgPath = getPrimaryImagePathFromOrderItem(item);
                    return (
                      <tr key={index} style={{ background: pickRowBackground(index, items, scannedCounts) }}>
                        <td className='align-middle text-center py-2'>
                          <div className='d-inline-flex justify-content-center'>
                            <ScannerPickImageWithLightbox imagePath={imgPath} alt={item.name || ''} size={44}
                              personalDiscount={item.personalDiscount} productDiscount={item.productDiscount}
                              price={item.price} discountedPrice={item.discountedPrice} />
                          </div>
                        </td>
                        <td className='align-middle py-2'>
                          <span title={item.name}>{item.name}</span>
                        </td>
                        <td className='align-middle py-2 text-monospace'>{item.productCode || '—'}</td>
                        <td className='align-middle py-2 text-monospace'>{item.barcode || '—'}</td>
                        <td className='align-middle py-2 text-center font-weight-bold text-nowrap'>
                          {got}/{need}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>

            {hasWrong ? (
              <div className='mt-3'>
                <p className='font-weight-bold small text-danger mb-2 mb-0'>Не з замовлення (зайве сканування)</p>
                <div className='table-responsive border rounded'>
                  <table className='table table-sm table-bordered mb-0 small'>
                    <tbody>
                      {wrongScans.map((w) => (
                        <tr key={w.id} style={{ background: '#f8d7da' }}>
                          <td className='align-top py-2'>
                            <WrongScanDetails w={w} />
                          </td>
                          <td className='align-top py-2 text-right' style={{ width: 44 }}>
                            <button
                              type='button'
                              className='btn btn-link btn-sm text-danger p-0'
                              onClick={() => removeWrong(w.id)}
                              title='Прибрати зі списку'
                            >
                              <i className='bi bi-trash' />
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            ) : null}
          </div>

          <div className='modal-footer py-2 px-3'>
            <button type='button' className='btn btn-secondary' onClick={onHide}>
              Закрити
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminOrderScannerPickModalDesktop;
